import { C1LinkButton } from 'components/core/button'
import { unsafeRoute } from 'lib/routes'
import { FormattedMessage } from 'react-intl'

interface Downloadable {
    downloadUrl: string
}

type DownloadProps = {
    downloadable: Downloadable
    variant?: 'link' | 'button'
}

const Download = ({ downloadable, variant = 'link' }: DownloadProps): React.ReactElement => (
    <>
        {variant === 'link' && (
            <a href={downloadable.downloadUrl} download>
                <FormattedMessage id="components_download_btn" defaultMessage="Download" />
            </a>
        )}
        {variant === 'button' && (
            <C1LinkButton variant="outlined" color="primary" href={unsafeRoute(downloadable.downloadUrl)}>
                <FormattedMessage id="components_download_btn" defaultMessage="Download file" />
            </C1LinkButton>
        )}
    </>
)
export default Download
